import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomSale } from 'src/app/models/custom-sale.schema';
import { DeliveryStatus, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { CustomPaymentsService } from 'src/app/services/custom-payments.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Product, ProductVariants } from './../../models/product.schema';

@Component({
  selector: 'app-custom-sale-delivery-details',
  templateUrl: './custom-sale-delivery-details.component.html',
  styleUrls: ['./custom-sale-delivery-details.component.scss']
})
export class CustomSaleDeliveryDetailsComponent implements OnInit {

  primaryIdOfSale: string;
  checkoutSessionId: string;
  customVendita: CustomSale;
  lineItems: any[] = [];
  subtotal: number = 0;
  shippingPrice: number = 0;
  taxPrice: number = 0;
  totalPrice: number = 0;
  currentStatus: string;
  statuses: string[] = [];
  steps: any[] = [];
  platform: string;
  
  currentStepIndex: number = 0; 
  isNotDelivered: boolean = false;
  basicInfo: {
    id: string,
    deliveryDate: string,
    deliveryTime: string,
    address: string,
    firstName: string,
    lastName: string,
    intercom: string,
    phone: string,
    notes: string,
    greetingNote: string,
  }
  lineItemsData: any = [];
  showingCurrentStatus: string;

  readonly orderedStatuses = [
    'created',
    'assigned',
    'delivering',
    'delivered',
    'notdelivered',
    'canceled',
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customPaymentsService: CustomPaymentsService,
    private spinnerService: SpinnerService,
  ) { }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      this.route.queryParams.subscribe(params => {
        this.primaryIdOfSale = params['sale_id'];
        this.platform = params['platform'];
        this.checkoutSessionId = params['session_id'];
      });

      if (this.primaryIdOfSale) {
        try {

          if (this.platform && ['shopifysale', 'cakesales', 'flowerssales', 'businesssales', 'deluxyexperiencesales', 'deluxydotcomsales'].includes(this.platform)) {
            const sale = await this.customPaymentsService.getSaleWithDeliveryInfo(this.primaryIdOfSale, this.platform);
            this.shippingPrice = sale?.totalShippingAmount || 0;
            if(sale?.customSale) {
              const sale = await this.customPaymentsService.getCustomSaleWithDeliveryInfo(this.primaryIdOfSale, this.platform);
              // console.log(`${this.platform?.toUpperCase()}_CUSTOM_SALE`, sale);
              await this.maintainBasicInformation(sale);
              await this.maintainProductsInformation(sale);
              await this.maintainTotals(sale);
              await this.maintainSaleStatus(sale);

              if (!sale) {
                this.router.navigateByUrl("/404", { skipLocationChange: true });
                return;
              }

              return;
            } else {
              // console.log(`${this.platform?.toUpperCase()}_AUOMATION_SALE`, sale);
              await this.maintainBasicInformation(sale);
              await this.maintainProductsInformation(sale);
              await this.maintainTotals(sale);
              await this.maintainSaleStatus(sale);
            }
          }
        }
        catch (e) {
          this.spinnerService.hide();
          console.error("Error fetching custom sale details:", e);
          this.router.navigateByUrl("/404", { skipLocationChange: true });
        }
      }
      this.spinnerService.hide();
    } catch (error) {
      this.spinnerService.hide();
      console.error(error);
    } finally {
      this.spinnerService.hide();
    }
  }

  async maintainBasicInformation(sale: any) {

    // console.log("deliveries", sale?.deliveries);

    this.basicInfo = {
      id: sale.id,
      deliveryDate: sale?.deliveryDate,
      deliveryTime: sale?.deliveryTime,
      address: sale?.address,
      firstName: sale?.firstName,
      lastName: sale?.lastName,
      intercom: sale?.intercom,
      phone: sale?.phone,
      notes: sale?.notes,
      greetingNote: sale?.greetingNote,
    }

  }

  async maintainSaleStatus(sale: any) {
    try {
      this.customVendita = sale;
      const deliveries = this.customVendita?.deliveries || [];

      if (!deliveries.length) {
        this.currentStatus = DeliveryStatus.created.toLowerCase();
        return;
      }

      const orderedStatuses = [
        DeliveryStatus.created.toLowerCase(),
        DeliveryStatus.accepted.toLowerCase(),
        DeliveryStatus.assigned.toLowerCase(),
        DeliveryStatus.delivering.toLowerCase(),
        DeliveryStatus.delivered.toLowerCase(),
        DeliveryStatus.notDelivered.toLowerCase(),
        DeliveryStatus.canceled.toLowerCase(),
      ];

      const allStatuses = deliveries
        .map((d: any) => d.status?.toLowerCase())
        .filter((s: string) => orderedStatuses.includes(s));

      if (!allStatuses.length) {
        this.currentStatus = DeliveryStatus.created.toLowerCase();
        return;
      }

      let minIndex = orderedStatuses.length;
      /*
      allStatuses.forEach((status: string) => {
        const index = orderedStatuses.indexOf(status);
        if (index !== -1 && index < minIndex) {
          minIndex = index;
        }
      });
      */

      allStatuses.forEach((status: string) => {
        const index = orderedStatuses.indexOf(status);

        const effectiveIndex =
          status === DeliveryStatus.accepted.toLowerCase()
            ? orderedStatuses.indexOf(DeliveryStatus.created.toLowerCase())
            : index;

        if (effectiveIndex !== -1 && effectiveIndex < minIndex) {
          minIndex = effectiveIndex;
        }
      });

      this.currentStatus = orderedStatuses[minIndex];
      this.showingCurrentStatus = DeliveryStatusAux.trackingAux[this.currentStatus]?.ln?.it || '';

      this.statuses = this.getStatuses(deliveries);
      this.isNotDelivered = this.checkIfNotDelivered();
      this.steps = this.getSteps();

      const currentStep = this.steps.find(step => step.status === this.currentStatus);
      let targetIndex = currentStep ? this.steps.indexOf(currentStep) + 1 : 0;

      if (currentStep?.status === 'created' && targetIndex < this.steps.length) {
        targetIndex++;
      }

      if (targetIndex > 0) {
        this.currentStepIndex = 0;
        setTimeout(() => this.animateStatusChange(targetIndex), 50);
      } else {
        this.currentStepIndex = 0;
      }

    } catch (error) {
      console.error('Error maintaining sale status:', error);
    }
  }

  getStatuses(deliveries: any[]): string[] {
    return deliveries
      .map(d => d.status?.toLowerCase())
      .filter(status => this.orderedStatuses.includes(status)) || [];
  }

  getSteps(): any[] {
    let baseSteps = [
      { label: 'Ordine confermato', icon: 'fas fa-check-circle', status: 'created' },
      { label: 'In creazione dall’Artista', icon: 'fas fa-truck-pickup', status: 'assigned' },
      { label: 'Sulla strada', icon: 'fas fa-shipping-fast', status: 'delivering' },
    ];

    if (this.currentStatus !== 'canceled') {
      if (this.isNotDelivered) {
        baseSteps.push({ label: 'Non Consegnato', icon: 'fas fa-times-circle', status: 'notdelivered' });
      } else {
        baseSteps.push({ label: 'Consegnato', icon: 'fas fa-box', status: 'delivered' });
      }
    }

    if (this.currentStatus === 'canceled') {
      baseSteps.push({ label: 'Annullato', icon: 'fas fa-times-circle', status: 'canceled' });
    }

    return baseSteps;
  }

  checkIfNotDelivered(): boolean {
    return this.currentStatus === DeliveryStatus.notDelivered.toLowerCase();
  }

  animateStatusChange(targetIndex: number) {
    if (this.currentStepIndex >= targetIndex) return;

    const stepDelay = 800; 
    const interval = setInterval(() => {
      this.currentStepIndex++;

      if (this.currentStepIndex >= targetIndex) {
        clearInterval(interval);
      }
    }, stepDelay);
  }

  isStepActive(index: number): boolean {
    return index < this.currentStepIndex;
  }

  isStepNotDelivered(index: number): boolean {
    return (index < this.currentStepIndex && (this.isNotDelivered || this.currentStatus === 'canceled'));
  }


  getOrderStatus(deliveries: any[]): string {
    if (!deliveries || deliveries.length === 0)
      return DeliveryStatus.created.toLowerCase();

    const statuses = deliveries.map(d => d.status?.toLowerCase());

    if (statuses.includes(DeliveryStatus.notDelivered.toLowerCase()))
      return DeliveryStatus.notDelivered.toLowerCase();
    if (statuses.includes(DeliveryStatus.delivered.toLowerCase()))
      return DeliveryStatus.delivered.toLowerCase();
    if (statuses.includes(DeliveryStatus.delivering.toLowerCase()))
      return DeliveryStatus.delivering.toLowerCase();
    if (statuses.includes(DeliveryStatus.assigned.toLowerCase()))
      return DeliveryStatus.assigned.toLowerCase();

    return DeliveryStatus.created.toLowerCase();
  }

  async maintainProductsInformation(sale: any) {

    try {

      if (sale?.customSale) {
        const lineItems = sale?.customSaleLineItems ? JSON.parse(sale.customSaleLineItems) : [];

        this.lineItemsData = lineItems.filter((item) => {
                              return !item?.product?.hiddenProduct;
                            }).map((item: any) => {
                              const product = item?.product || {};
                              const variant = product?.productVariant || null;

                              /*
                              console.log("product", product)
                              console.log("product?.id", product?.id);
                              console.log("product?.name", product?.name);
                              console.log("product?.image", product?.image);
                              console.log("product?.productImage", product?.productImage);
                              console.log("product?.quantity", product?.quantity);
                              console.log("==============================================");
                              console.log("variant", variant);
                              console.log("variant?.variantName", variant?.variantName);
                              console.log("variant?.variantPrice", variant?.variantPrice);
                              console.log("variant?.variantShopifyPrice", variant?.variantShopifyPrice);
                              */

                              return {
                                product: {
                                  id: product.id || null,
                                  name: product.name || null,
                                  image: product.productImage || product.image || null,
                                  productVariant: variant
                                    ? {
                                        id: variant.id || null,
                                        variantName: variant.variantName || null,
                                        variantPrice: variant.variantPrice || 0,
                                        variantShopifyPrice: variant.variantShopifyPrice || 0,
                                      }
                                    : null,
                                  productPublicPrice: product.productPublicPrice || 0,
                                  quantity: product.quantity || 1,
                                  hiddenProduct: product.hiddenProduct ?? false,
                                },
                              };
                            });
        // console.log('this.lineItemsData', this.lineItemsData);
      } else {
        const lineItems = sale?.lineItems ? JSON.parse(sale.lineItems) : [];
        // console.log("lineItems", lineItems)
        let productData: { product: Product, productVariant: ProductVariants }[] = [];

        for(let item of lineItems) {
          const shippingAddress = JSON.parse(sale['shippingAddress']);
          const provinceCode = shippingAddress?.province_code;
          const baseSku = item?.sku;
          const skuWithProvince = baseSku + provinceCode;
          const quantity = String(item?.quantity) || String(1);
          let existingProduct: Product = null;
          let productVariantForDelivery: ProductVariants = null;

          if(baseSku || skuWithProvince) {
            // 1. Try to find variant by SKU+province first, then base SKU
            const skusToTry = [skuWithProvince, baseSku];
            for (const sku of skusToTry) {
                const productVariant = await this.customPaymentsService.getVaraintBySku(sku);
                if (productVariant?.product?.id) {
                  productVariantForDelivery = productVariant;
                  existingProduct = productVariant.product;
                  if (existingProduct) break;
                }
            }
          }

          if (!existingProduct && provinceCode) {
            existingProduct = await this.customPaymentsService.getProductBySku(skuWithProvince);
          }

          // 3. Try finding product directly by base SKU
          if (!existingProduct && baseSku) {
            existingProduct = await this.customPaymentsService.getProductBySku(baseSku);
          }

          existingProduct.quantity = quantity;

          productData.push({
            product: existingProduct,
            productVariant: productVariantForDelivery
          });
        }

        this.lineItemsData = productData.map((item: any) => {
                              const product = item?.product || {};
                              const variant = item?.productVariant || null;

                              return {
                                product: {
                                  id: product.id || null,
                                  name: product.name || null,
                                  image: product.productImage || product.image || null,
                                  productVariant: variant
                                    ? {
                                        id: variant.id || null,
                                        variantName: variant.variantName || null,
                                        variantPrice: variant.variantPrice || 0,
                                        variantShopifyPrice: variant.variantShopifyPrice || 0,
                                      }
                                    : null,
                                  productPublicPrice: product.productPublicPrice || 0,
                                  quantity: product.quantity || 1,
                                  hiddenProduct: product.hiddenProduct ?? false,
                                },
                              };
                            });
      
        // console.log("this.lineItemsData ", this.lineItemsData )
      }
    } catch (error) {
      
    }

  }

  async maintainTotals(sale: any) {
    try {
      this.lineItems = sale?.customSaleLineItems ? JSON.parse(sale?.customSaleLineItems) : [];
      this.subtotal = 0;
      this.lineItemsData.filter((item) => {
        return !item?.product?.hiddenProduct;
      }).map((item) => {
        const product = item?.product || {};
        const variant = product?.productVariant || null;

        const unitPrice = variant?.variantShopifyPrice
          ? parseFloat(variant.variantShopifyPrice)
          : parseFloat(product.productPublicPrice || product.amount || '0');

        const quantity = parseInt(product.quantity, 10);
        const validQuantity = isNaN(quantity) || quantity <= 0 ? 1 : quantity;

        const validPrice = isNaN(unitPrice) || unitPrice <= 0 ? 0 : unitPrice;

        this.subtotal += validPrice * validQuantity;
      })

      this.totalPrice = (Number(this.subtotal) + (Number(this.shippingPrice) || 0) + (Number(this.taxPrice) || 0));

    } catch (error) {
      console.error('Error maintainTotals:', error);
    }
  }

}